import {
  checkHasIncorrectStatement,
  countIncorrectStatements,
  type GradingKnowledgeBaseAdherence,
} from "@repo/app-types/entities/knowledgeBaseAdherence";
import { IconAlertTriangle, IconCircleCheck } from "@tabler/icons-react";
import type { FC } from "react";

export interface IncorrectStatementsIndicationProps {
  knowledgeBaseAdherence: GradingKnowledgeBaseAdherence | null | undefined;
  isVisibleWhenZero?: boolean;
}

export const IncorrectStatementsIndication: FC<
  IncorrectStatementsIndicationProps
> = (props) => {
  const { knowledgeBaseAdherence } = props;

  if (knowledgeBaseAdherence === undefined || knowledgeBaseAdherence === null) {
    return null;
  }

  if (checkHasIncorrectStatement(knowledgeBaseAdherence)) {
    return (
      <div className="flex items-center gap-1 text-xs">
        <IconAlertTriangle className="size-5 shrink-0 text-orange-500" />

        <div className="text-orange-600">
          {countIncorrectStatements(knowledgeBaseAdherence)}
        </div>
      </div>
    );
  }

  if (props.isVisibleWhenZero) {
    return (
      <div className="">
        <IconCircleCheck className="size-5 shrink-0 text-green-500" />
      </div>
    );
  }

  return null;
};
